<script>

    export let radius = 0;
    export let width = 1;
    export let color = black;
    export let hover = color;
    export let stroke = "solid";

</script>

<div style="border: {width}px {stroke} {color}; border-radius:{radius}; " onMouseOut="this.style.borderColor='{color}'" onMouseOver="this.style.borderColor='{hover}'" >
    <slot/>
</div>

<style>
    div {
        overflow: hidden;
    }
</style>